import React from 'react';

/**
 * `fetchPriority` com a grafia que a versão de React instalada aceita sem aviso.
 *
 * O React 19 conhece `fetchPriority` (camelCase) e reclama de `fetchpriority`;
 * o React 18 — que `wp-blog` e `wp-support` usam — faz o contrário: avisa
 * "React does not recognize the `fetchPriority` prop" e só deixa passar o
 * minúsculo como atributo desconhecido. O atributo sai no HTML nos dois casos;
 * a diferença é o aviso no dev. O `next/image` resolve do mesmo jeito.
 */
export const fetchPriorityProps = (value: 'high' | 'low' | 'auto' | undefined): Record<string, string> => {
  if (!value) return {};
  return Number(React.version.split('.')[0]) >= 19 ? { fetchPriority: value } : { fetchpriority: value };
};
